module.exports = __webpack_public_path__ + "img/rms-title.a1d3064d.png";